/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Terms_TitleInputs */



/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Legal_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const legal_terms_title = /** @type {((inputs?: Legal_Terms_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Terms_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conditions d'utilisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Términos del servicio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Termos de Serviço")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termini di servizio")
	return /** @type {LocalizedString} */ ("Terms of Service")
});